import React from "react";
import { Box, ThemeProvider, Typography, createTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";
import Moment from "react-moment";
import { NumericFormat } from "react-number-format";
import { useAppSelector } from "../../../../shared/hooks/sharedHooks";
import { quantity } from "../../../../shared/models/models";
import { productCondition } from "../../../../common/models/CommonModels";
import { ChangeRfq, CustomerMyRfqsState, urgencyStatus } from "../../models/models";
import useTranslation from "../../../../shared/hooks/useTranslation";

const PublishStep = () => {
  const { manufacturers, categories } = useAppSelector<CustomerMyRfqsState>((state: any) => state.customerMyRfqs);
  const { getValues } = useFormContext<ChangeRfq>();
  const { translate } = useTranslation("common");

  const model = getValues();

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Box className="mt-5">
        <Typography fontSize={36} fontWeight={500} className="heading-1">
          Create a new RFQ
        </Typography>
      </Box>

      <Box className="mt-5">
        <Typography fontSize={24} fontWeight={500} className="heading-2">
          Check the details below and publish the RFQ
        </Typography>
      </Box>

      <Box className="flex items-center gap-10 mt-4 uppercase">
        <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
          Product details
        </Typography>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333", wordBreak: "break-all" }}>
            {model.productNumber}
          </Typography>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333", wordBreak: "break-all" }}>
            {model.productAlternativeNumber}
          </Typography>
        </Box>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            {manufacturers.find(x => x.id === model.manufacturerId)?.name}
          </Typography>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            {categories.find(x => x.id === model.categoryId)?.name}
          </Typography>
        </Box>
      </Box>

      <Box className="flex gap-10 mt-2 uppercase">
        <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
          Condition
        </Typography>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            {model.productConditionCodes?.map(x => translate(`productCondition.${productCondition(x)}`)).join(", ")}
          </Typography>
        </Box>
      </Box>

      {model.maxUnitPrice && (
        <Box className="flex gap-10 mt-2 uppercase">
          <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
            Target price
          </Typography>

          <Box sx={{ minWidth: "190px" }}>
            <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
              <NumericFormat value={model.maxUnitPrice as any as number} displayType="text" thousandSeparator=" " suffix="€" />/pc
            </Typography>
          </Box>
        </Box>
      )}

      <Box className="flex gap-10 mt-2 uppercase">
        <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
          Quantity
        </Typography>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            {quantity(model.quantity)}
          </Typography>
        </Box>
      </Box>

      <Box className="flex gap-10 mt-2 uppercase">
        <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
          Urgency
        </Typography>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            {urgencyStatus(model.urgencyCode)}
          </Typography>
        </Box>
      </Box>

      <Box className="flex gap-10 mt-2 uppercase">
        <Typography fontSize={12} fontWeight={500} className="text-12-medium" sx={{ minWidth: "190px" }}>
          Last call
        </Typography>

        <Box sx={{ minWidth: "190px" }}>
          <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
            <Moment date={model.lastCall} format="DD.MM.YYYY" />
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default PublishStep;
